module.exports = __webpack_public_path__ + "media/luxury-2026/estate-side-drone-960-f5a30e19.jpg";